module.exports = __webpack_public_path__ + "static/gradientSky-edit-c928e320c8c4052fc952db34137c106c.jpeg";